<template>
  <el-drawer
    title="接送详情"
    :visible.sync="visible"
    @close="close"
    size="1000px"
    :wrapperClosable="true"
    id="comDrawer"
    :modal-append-to-body="true"
    v-if="petdetail"
  >
    <div class="drawer">
      <div class="drawerTitle">预约客户</div>
      <div class="drawerViewR">
        <div>
          预约类型:
          <span v-if="petdetail.type == 1">接宠</span>
          <span v-if="petdetail.type == 2">送宠</span>
        </div>
        <div>
          提交时间:{{
            $public.FTime(petdetail.create_time, "YYYY-MM-DD HH:mm:ss")
          }}
        </div>
        <div v-if="petdetail.user_info">
          客户姓名：{{ petdetail.user_info.user_name }}
        </div>
        <div v-if="petdetail.user_info">
          客户电话：{{ petdetail.user_info.user_mobile }}
        </div>
      </div>
    </div>
    <div class="drawer">
      <div class="drawerTitle">预约信息</div>
      <div class="drawerViewR" v-if="petdetail.time_info">
        <div>
          预约日期：{{ petdetail.time_info.date }}{{ petdetail.time_name
          }}{{ $public.FTime(petdetail.start_time, "YYYY-MM-DD HH:mm:ss") }}
        </div>
        <div>联系人：{{ petdetail.adddress.user_name }}</div>
        <div>联系电话：{{ petdetail.adddress.phone }}</div>
        <div>
          接送宠地址:{{ petdetail.adddress.province_name
          }}{{ petdetail.adddress.city_name
          }}{{ petdetail.adddress.district_name
          }}{{ petdetail.adddress.address }}
        </div>
        <div>预约备注:{{ petdetail.remark }}</div>
        <!-- <div>核销券号:{{ petdetail.time_info }}</div> -->
        <div>
          预约状态:
          <span v-if="petdetail.state == 1">已提交</span>
          <span v-if="petdetail.state == 2">已审核</span>
          <span v-if="petdetail.state == 4">接送中</span>
          <span v-if="petdetail.state == 5">已完成</span>
          <span v-if="petdetail.state == -2">已取消</span>
        </div>
      </div>
    </div>
    <div class="drawer">
      <div class="drawerTitle">接送宠物</div>
      <div
        class="drawerViewR"
        v-for="(item, index) in petdetail.pet_list"
        :key="index"
      >
        <div>
          宠物种类:
          <span v-if="item.pet_type == 1">猫</span>
          <span v-if="item.pet_type == 2">狗</span>
        </div>
        <div>宠物品种：{{ item.pet_classname }}</div>
        <div>宠物名字：{{ item.pet_name }}</div>
        <div>宠物体重：{{ item.pet_weight }}kg</div>
      </div>
    </div>
    <div class="drawer" v-if="petdetail.cancle_info">
      <div class="drawerTitle">取消信息</div>
      <div class="drawerViewR">
        <div>
          取消时间:
          <span>{{
            $public.FTime(
              petdetail.cancle_info.cancle_time,
              "YYYY-MM-DD HH:mm:ss"
            )
          }}</span>
        </div>
        <div>
          取消原因:
          <span>
            {{ petdetail.cancle_info.cancle_type }}
          </span>
        </div>
        <div>备注原因{{ petdetail.cancle_info.cancle_remark }}</div>
      </div>
    </div>
    <div class="drawer" v-if="petdetail.shuttle_detail">
      <div class="drawerTitle">确认信息</div>
      <div class="drawerViewR">
        <div>
          接送方式:
          <span v-if="petdetail.shuttle_detail.shuttle_type == 1"
            >专车接送</span
          >
          <span v-if="petdetail.shuttle_detail.shuttle_type == 2"
            >员工接送</span
          >
        </div>
        <div>
          接送人员:
          <span
            v-for="item in petdetail.shuttle_detail.staff_list"
            :key="item.id"
          >
            {{ item.staff_name }}
          </span>
        </div>
        <div>
          预计接送时间:{{ petdetail.shuttle_detail.shuttle_time.date + " "
          }}{{ petdetail.shuttle_detail.shuttle_time.start_time }}
        </div>
      </div>
    </div>

    <div class="drawer" v-if="petdetail.shuttle_success">
      <div class="drawerTitle">送达信息</div>
      <div class="drawerViewR">
        <div>
          接送人员:
          <span
            v-for="item in petdetail.shuttle_success.staff_list"
            :key="item.id"
          >
            {{ item.staff_name }}
          </span>
        </div>
        <div>
          接送完成时间:
          <span>
            {{
              $public.FTime(
                petdetail.shuttle_success.success_time,
                "YYYY-MM-DD HH:mm:ss"
              )
            }}
          </span>
        </div>
      </div>
      <div class="drawerViewR">
        <span style="margin-left: 10px">确认送达凭证:</span>
        <span v-for="item in petdetail.shuttle_success.images" :key="item.id">
          <img
            :src="item"
            style="width: 150px; height: 150px; margin-left: 10px"
          />
        </span>
      </div>
    </div>
    <!-- 接送中 -->
    <div class="drawer" v-if="petdetail.state == 4">
      <div class="drawerTitle">送达信息</div>
      <div class="drawerViewT">
        <div>
          接送人员:<el-select
            v-model="curStaffId"
            multiple
            filterable
            placeholder="请选择"
            size="mini"
          >
            <el-option
              popper-class="select"
              v-for="item in staff_list"
              :key="item._id"
              :label="item.basic_info.nick_name"
              :value="item._id"
            ></el-option>
          </el-select>
        </div>
        <div>
          送达凭证:
          <div class="screenLine">
            <div class="drawerComR" style="display: flex">
              <div
                v-for="(item, index) in images"
                :key="index"
                class="imgItem"
                style="display: inline-block"
              >
                <img
                  alt=""
                  :src="item"
                  v-if="images.length > 0"
                  class="avatar"
                />
                <i
                  class="el-icon-error closeBtn"
                  v-if="images.length > 0"
                  @click="handleDeleteBannerImgClick(index)"
                ></i>
              </div>
              <i
                v-if="images.length == 0"
                class="el-icon-plus avatar-uploader-icon"
                @click="handleUploadClick"
              ></i>
              <input
                type="file"
                ref="file"
                style="width: 0; height: 0"
                @change="changeFile"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="drawer" v-if="petdetail.state == 1 || petdetail.state == 2">
      <div class="drawerTitle">确认信息</div>
      <div class="drawerMsg">
        接送确认：
        <el-radio v-model="radio" :label="true" :disabled="petdetail.state == 2"
          >确认接送</el-radio
        >
        <el-radio v-model="radio" :label="false">取消预约</el-radio>
      </div>
      <div class="drawerMsg" v-if="radio">
        接送方式：
        <el-radio v-model="shuttle_type" :label="1">专车接送</el-radio>
        <el-radio v-model="shuttle_type" :label="2">员工接送</el-radio>
      </div>
      <div class="drawerMsg" v-if="radio">
        接送人员：
        <el-checkbox-group v-model="staff" @change="handledataChange">
          <el-checkbox-button
            v-for="item in staff_list"
            :key="item._id"
            :label="
              item._id +
              ',' +
              item.basic_info.nick_name +
              ',' +
              item.basic_info.user_mobile
            "
            :value="item._id"
            >{{ item.basic_info.nick_name }}</el-checkbox-button
          >
        </el-checkbox-group>
      </div>
      <div class="drawerMsg" v-if="radio">
        接送日期：
        <el-date-picker
          v-model="time_info.date"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="{
            disabledDate(date) {
              return date.getTime() <= Date.now() - 86400000;
            },
          }"
          placeholder="选择日期"
        >
        </el-date-picker>
      </div>
      <div class="drawerMsg" v-if="radio">
        接送时间：
        <el-time-picker
          v-model="time_info.start_time"
          value-format="HH:mm"
          format="HH:mm"
          :picker-options="{ format: 'HH:mm' }"
          placeholder="任意时间点"
        >
        </el-time-picker>
      </div>
      <div class="drawerMsg" v-if="radio">
        接送人员电话：
        <el-input
          v-model="mobile"
          style="width: 300px"
          placeholder="请输入内容"
        ></el-input>
      </div>
      <div class="drawerMsg" v-if="!radio">
        取消原因：
        <el-select v-model="cancelCause" placeholder="请选择">
          <el-option
            v-for="item in cancelCauseList"
            :key="item._id"
            :label="item.item_name"
            :value="item.item_name"
          >
          </el-option>
        </el-select>
      </div>
      <div class="drawerMsg" v-if="!radio">
        备注原因：
        <el-input
          type="textarea"
          v-model="cancle_remark"
          style="width: 500px"
        ></el-input>
      </div>
    </div>
    <div class="drawerViewB">
      <div
        class="btn2"
        @click="close"
        v-if="petdetail.state == 1 || petdetail.state == 2"
      >
        取消
      </div>
      <div
        class="btn"
        @click="submit"
        v-if="petdetail.state == 1 || petdetail.state == 2"
      >
        确定
      </div>
      <div class="btn2" v-if="petdetail.state == 4" @click="successPetShuttle">
        确认送达
      </div>
    </div>
  </el-drawer>
</template>
<script>
export default {
  data() {
    return {
      // 接送中接送人员
      curStaffId: [],
      images: [],
      petdetail: [],
      visible: true,
      radio: true,
      shuttle_type: 1,
      value1: "",
      time_info: {
        date: "",
        start_time: "",
        dateTime: "",
      },
      staff_list: [], //销售人员列表
      staff_list1: [], //销售人员列表
      staff: [],
      cancelCauseList: [],
      cancelCause: "", //取消原因
      cancle_remark: "",
      staffList: [], //选择接送的员工
      mobile: "",
    };
  },
  props: {
    id: {
      default: "",
    },
  },

  computed: {},
  mounted() {
    this.getListDetail();
    this.getStaffList();
    this.getDataBase();
  },
  created() {
    // this.time_info.date = new Date().;
  },
  methods: {
    // 确认送达
    successPetShuttle() {
      if (!this.curStaffId.length) {
        this.$message({
          showClose: true,
          message: "请添加接送人员",
        });
        return;
      }
      if (!this.images.length) {
        this.$message({
          showClose: true,
          message: "请上传送达凭证",
        });
        return;
      }
      let staff_list = [];
      for (let i = 0; i < this.curStaffId.length; i++) {
        staff_list.push({
          staff_id: this.curStaffId[i],
          staff_name: this.$public.getMatchingItem(
            this.staff_list,
            "_id",
            this.curStaffId[i]
          ).basic_info.nick_name,
        });
      }
      let params = {
        id: this.id,
        images: this.images,
        staff_list: staff_list,
      };
      console.log(params, "params");
      let loading = this.$loading();
      this.$http
        .post(process.env.VUE_APP_AppAdmin + "/api/PetShuttle/Success", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$emit("submit", {
              type: "close",
            });
            this.$message({
              type: "success",
              message: "完成接送!",
            });
          }
        });
    },
    //上传轮播图
    changeFile(e) {
      let that = this;
      var index = e.target.files[0].name.lastIndexOf(".");
      var ext = e.target.files[0].name.substr(index + 1);
      var formData = new FormData();
      if (ext === "png" || ext === "jpg" || ext === "jpeg") {
        formData.append("img", e.target.files[0]);
        this.$upload
          .uploadImg_dir(formData, { dir: "businessShopImg" })
          .then((data) => {
            if (data.timestamp) {
              that.images.push(data.url);
            }
          });
      } else {
        this.$message({
          message: "只能上传jpg,png格式的文件",
          type: "error",
        });
      }
    },
    //删除轮播图图片
    handleDeleteBannerImgClick(index) {
      this.images.splice(index, 1);
    },
    //转移触发轮播图上传按钮
    handleUploadClick() {
      this.$refs.file.click();
    },
    close() {
      this.$emit("close", {
        type: "close",
      });
    },
    submit() {
      if (this.radio) {
        this.time_info.dateTime =
          this.time_info.date + " " + this.time_info.start_time;
        let params = {
          id: this.id,
          shuttle_type: this.shuttle_type,
          shuttle_time: this.time_info,
          staff_list: this.staffList,
          mobile: this.mobile,
        };
        console.log(params, "params");
        let loading = this.$loading();
        this.$http
          .post(
            process.env.VUE_APP_AppAdmin + "/api/PetShuttle/Confirm",
            params
          )
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "确认接送",
              });
              this.$emit("submit", {
                type: "close",
              });
            }
          });
      } else if (!this.radio) {
        let params = {
          id: this.id,
          cancle_type: this.cancelCause,
          cancle_remark: this.cancle_remark,
        };
        console.log(params, "params");
        this.$http
          .post(process.env.VUE_APP_AppAdmin + "/api/PetShuttle/Cancle", params)
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                type: "success",
                message: "取消预约",
              });
              this.$emit("submit", {
                type: "close",
              });
            }
          });
      }
    },
    // 非全选
    handledataChange(item) {
      if (item.length) {
        let staffList = [];
        item.forEach((i) => {
          let arr = i.split(",");
          let obj = {
            staff_id: arr[0],
            staff_name: arr[1],
          };
          staffList.push(obj);
        });
        this.mobile = item[0].split(",")[2];
        this.staffList = staffList;
        console.log(staffList, "staffList");
      }
    },
    // 获取取消原因
    getDataBase() {
      let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_zichan +
            "/api/SystemConfig/GetSystemDictionByCode",
          { code: "quxiaoyuyue" }
        )
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            console.log("字典信息", res);
            this.cancelCauseList = res.data.item_list || [];
          }
        });
    },
    // 获取员工列表
    getStaffList() {
      let params = {
        keyword: "",
        pageIndex: 1,
        pageSize: 500,
      };
      let loading = this.$loading();
      this.$http.get("/api/Staff/List", params).then((res) => {
        loading.close();
        if (res.code == 0) {
          this.staff_list = res.data.data;
          res.data.data.forEach((item) => {
            const obj = {
              id: item._id,
              name: item.basic_info.nick_name,
              mobile: item.basic_info.user_mobile,
            };
            this.staff_list1.push(obj);
          });
          console.log(this.staff_list1, " this.staff_list1");
        }
      });
    },
    // 获取接送详情
    getListDetail() {
      let params = {
        id: this.id,
      };
      this.$http
        .get(process.env.VUE_APP_AppAdmin + "/api/PetShuttle/Get", params)
        .then((res) => {
          this.petdetail = res.data;
          if (res.data.state == 2) {
            this.radio = false;
          }
          let staff_list = res.data.shuttle_detail.staff_list;
          for (let b = 0; b < staff_list.length; b++) {
            this.curStaffId.push(staff_list[b].staff_id);
          }
          console.log(this.time_info, "Dogdetail");
        });
    },
  },
};
</script>
<style scoped lang="scss">
.drawer {
  .drawerTitle {
    padding: 10px 20px;
    margin: 20px 10px;
    font-size: 18px;
    font-weight: 700;
    background-color: rgb(227, 227, 230, 0.5);
    border-left: 8px solid rgb(136, 136, 193);
  }
  .drawerView {
    display: flex;
  }
  .drawerViewT {
    margin: 5px 10px;
    flex-wrap: wrap;
    div {
      margin: 10px 10px;
    }
  }
  .avatar {
    width: 100px;
    height: 100px;
  }
  .avatar-uploader-icon {
    margin-top: 10px;
    margin-bottom: 10px;
    font-size: 50px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    border: 1px #8c939d dashed;
    line-height: 100px;
    text-align: center;
  }
  .drawerViewR {
    display: flex;
    margin-left: 10px;
    margin: 5px 10px;
    flex-wrap: wrap;
    font-size: 13px;
    .tltle {
      margin-left: 10px;
    }
    div {
      width: 30%;
      margin: 10px 10px;
    }
  }
  .drawerCol {
    display: flex;
    flex-wrap: wrap;
    div {
      margin: 0 10px;
    }
  }
}
.drawerMsg {
  margin: 25px 20px;
  font-size: 14px;
}
.el-checkbox-group {
  ::v-deep .el-checkbox-button {
    margin: 10px 20px;
    border: 1px solid gainsboro;
  }
}
#comDrawer {
  ::v-deep .el-drawer__header {
    padding: 10px;
    margin-bottom: 0;
  }
  ::v-deep .el-drawer__body {
    height: calc(100% - 65px);
    overflow-y: auto;
  }
}
.drawerViewB {
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 20px;
  border-top: solid 1px #f2f2f2;
  box-sizing: border-box;
  .btn {
    width: 98px;
    line-height: 40px;
    text-align: center;
    background: linear-gradient(135deg, #f5882a 0%, #f5882a 100%);
    border-radius: 10px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    cursor: pointer;
    margin-left: 20px;
  }
  .btn2 {
    width: 98px;
    line-height: 40px;
    text-align: center;
    border-radius: 10px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
    box-sizing: border-box;
    border: solid 1px #f5882a;
    color: #f5882a;
  }
}
</style>
